/*
 * Copyright Mimic Networks, Inc. 2024.
 */

export function EmptyFragment() {
  // This is not actually useless and '' or undefined won't work in many places
  /* eslint-disable-next-line react/jsx-no-useless-fragment */
  return <></>;
}
